import { createI18n } from "vue-i18n"
import de from "./lang/de.json"
import en1 from "./lang/en.json"
import ja from "./lang/ja.json"
import zhCn from "./lang/zh-cn.json"
import zhtw from "./lang/zh-TW.json"

export const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem("language") || "zhCn", // 默认显示语言
  fallbackLocale: "en",
  messages: {
    zhCn,
    en: en1,
    ja,
    de,
    zhtw
  }
})
